<!--

首页Banner大图

使用说明：

<Banner
    :banners="[{img: '图片地址', link: '点击后跳转路径'}]"
/>

-->
<template>
    <div class="wrap">
        <swiper :options="swiperOption" ref="banners" @slideChangeTransitionEnd="slideChangeTransitionEnd">
                <swiper-slide v-for="b in banners" :key="b.img">
                    <!-- <Icon class="banner-img" :img="b.img" size="cover" @click.native="goto(b)"/> -->
                    <div @click="goto(b)" class="banner-img">
                        <img :src="b.img" style="width: 100%">
                    </div>
                    
                </swiper-slide>
                <div class="swiper-pagination banner-pagination"  slot="pagination"></div>
        </swiper>
        
    </div>
</template>

<script>
import store from '../../api/store'
import { swiper, swiperSlide } from 'vue-awesome-swiper'


export default {
  props: ['banners'],
  components:{
    swiper,
    swiperSlide
  },
    data() {
        return {
            swiperOption: {//以下配置不懂的，可以去swiper官网看api，链接http://www.swiper.com.cn/api/
                // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，<br>　　　　　　　　假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                notNextTick: true,
                // swiper configs 所有的配置同swiper官方api配置
                autoplay:  {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: true,
                },
                direction : 'horizontal',
                grabCursor : true,
                setWrapperSize :true,
                autoHeight: true,
                pagination : {
                    el: '.swiper-pagination',
                    clickable: true
                },
                scrollbar:'.swiper-scrollbar',//滚动条
                mousewheelControl : true,
                observeParents:true,
            }
        }
    },
    methods: {
        slideChangeTransitionEnd() {
            var activeIndex = this.$refs.banners.swiper.activeIndex
            this.$emit('slideChangeTransitionEnd', activeIndex)
        },
        goto(banner){
            var link = banner.link;
            console.log('Link:' + link);
            if(!link  || link == '#'){//忽略无效的链接
                return;
            }
            if(link.startsWith('http://') || link.startsWith('https://')){ //绝对链接
                window.location.href = link;
            }else{ //相对链接
                this.$routerPush(this, link);
            }

        }
    }

}
</script>

<style lang="less">
@import '../../../static/swiper.min.css';

.wrap {
    position: relative;
    z-index: 2;
}

.banner-img{
    width: 100vw;
    height: 34.66vw;
    background-position: center;
    background-size: cover;
}

.banner-pagination{

    .swiper-pagination-bullet{
        border: 0.3vw solid #fff;
        background: transparent;
        width: 1.4vw;
        height: 1.4vw;
        border-radius: 50%;
        transition: all .3s ease;
        opacity: 1;
        
    }

    .swiper-pagination-bullet-active{
        background: @themeColor;
        width: 2.9vw;
        height: 1.8vw;
        border-radius: 1.8vw;
        border: 0;
    }

}


    
</style>





// WEBPACK FOOTER //
// src/components/homepage/Banner.vue